import BeerGrid from './BeerGrid';
export default BeerGrid;
